import { OUTCOME_TYPES } from '../outcomeApi';

export const REPORT_OUTCOMES = [
  ...OUTCOME_TYPES.map(o => ({ key: o.key, label: o.label })),
  { key: 'email_sent', label: 'Email sent' },
];
export const DEFAULT_REPORT_OUTCOMES = REPORT_OUTCOMES.map(o => o.key).filter(k => k !== 'email_sent');

export const OUTCOME_COLORS = {
  will_refer: '#059669', meeting_set_up: '#4f46e5', meeting_result: '#7c3aed', call_back_later: '#0284c7',
  converted: '#16a34a', wants_more_info: '#d97706', no_response: '#9ca3af', note: '#f97316',
  not_interested: '#dc2626', wont_refer_dormant: '#7f1d1d', email_sent: '#0ea5e9',
};

export function ChipMultiSelect({ options, selected, onChange, testPrefix }) {
  const toggle = (k) => onChange(selected.includes(k) ? selected.filter(x => x !== k) : [...selected, k]);
  return (
    <div className="flex flex-wrap gap-1.5">
      {options.map(o => {
        const on = selected.includes(o.key);
        return (
          <button key={o.key} type="button" onClick={() => toggle(o.key)} data-testid={`${testPrefix}-${o.key}`}
            className={`px-2.5 py-1 rounded-md text-xs border flex items-center gap-1.5 transition-colors ${on ? 'bg-orange-50 border-orange-400 text-orange-800 font-medium' : 'bg-white text-muted-foreground hover:border-orange-200'}`}>
            {o.color && <span className="w-2 h-2 rounded-full" style={{ background: o.color }} />}
            {o.label}
          </button>
        );
      })}
      <button type="button" onClick={() => onChange(options.map(o => o.key))} className="px-2 text-xs text-orange-700 hover:underline" data-testid={`${testPrefix}-all`}>All</button>
      <button type="button" onClick={() => onChange([])} className="px-2 text-xs text-muted-foreground hover:underline" data-testid={`${testPrefix}-none`}>None</button>
    </div>
  );
}
